import { Component, OnInit } from '@angular/core';
import { Router,RouterModule} from '@angular/router';
import {LoginService} from '../login.service';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-participation',
  templateUrl: './participation.component.html',
  styleUrls: ['./participation.component.css']
})
export class ParticipationComponent implements OnInit {
  trackComponent:Boolean = false;
  workfare:Boolean = false;

  constructor(public router:Router, public loginService:LoginService, public toastService:ToastrService) { }

  ngOnInit() {
      this.load();
  }
  load(){
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    let request = {
      perId:this.loginService.personId
    }
    this.loginService.getParticipation(request).subscribe((data:Array<Object>)=>{
      if(data[0]['@trackComponent'] == 0 && CryptoJS.AES.decrypt(sessionStorage.getItem('status'), key).toString(CryptoJS.enc.Utf8) == 'SNAP RTW/Workfare'){
        this.trackComponent = false;
        this.workfare = true;
        sessionStorage.setItem('track','false');
        sessionStorage.setItem('workfare','true');
      }
      else if(data[0]['@workfare'] == 0 && CryptoJS.AES.decrypt(sessionStorage.getItem('status'), key).toString(CryptoJS.enc.Utf8) != 'SNAP RTW/Workfare'){
        this.trackComponent = true;
        this.workfare = false;
        sessionStorage.setItem('track',CryptoJS.AES.encrypt('true',key).toString());
        sessionStorage.setItem('workfare',CryptoJS.AES.encrypt('false',key).toString());
      }
      else{
        this.trackComponent = true;
        this.workfare = true;
        sessionStorage.setItem('track',CryptoJS.AES.encrypt('true',key).toString());
        sessionStorage.setItem('workfare',CryptoJS.AES.encrypt('true',key).toString());
      }
    },error=>{
      this.toastService.error("Unable to load Participation Codes","My Participation");
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/participation/participation.component.ts